import { render, staticRenderFns } from "./private_lesson_settings.vue?vue&type=template&id=92708f82&"
import script from "./private_lesson_settings.vue?vue&type=script&lang=js&"
export * from "./private_lesson_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports